import { call, delay, put, select } from 'redux-saga/effects';
import * as R from 'remeda';
import { suggestionSelectors } from 'store/data/suggestion';
import { createAction } from 'store/glue/operation/createAction';
import { initializeSuggestions } from 'store/glue/operation/initializeSuggestions';
import { sagaWrapper } from 'store/helpers';
import { ActionType } from 'typesafe-actions';
import { timeUtility } from 'utility';

import * as improvementsActions from './actions';

// Creates a new action pre-populated from an existing suggestion, then
// refreshes the suggestion to reflect its new actionIds linkage.
export function* startCreateActionFromSuggestionSaga(
  action: ActionType<
    typeof improvementsActions.startCreateActionFromSuggestion
  >,
) {
  function* saga() {
    const { suggestionId } = action.payload;

    const suggestion: ReturnType<typeof suggestionSelectors.item> =
      yield select(suggestionSelectors.item, {
        id: suggestionId,
      });
    if (!R.isDefined(suggestion)) return;

    const today = timeUtility.getToday();
    const tomorrow = timeUtility.step({
      step: 'next',
      stepSize: 'week',
      timeDate: today,
    });

    const _action: Data.Action = {
      id: R.randomString(10),
      improvementAreaId: null,
      name: suggestion.name,
      suggestionIds: [suggestion.id],
      problemStatement: suggestion.problemStatement,
      solutionProposal: suggestion.solutionProposal,
      responsibleEmployee: null,
      definitionOfDone: '-',
      endAt: tomorrow,
      priority: 'None',
      startAt: today,
      status: 'New',
    };

    const createdAction: Data.Action | undefined = yield call(createAction, {
      action: _action,
    });
    if (!R.isDefined(createdAction)) return;

    yield put(improvementsActions.setSelectedActionId(createdAction.id));

    // Switch to the actions tab so the new action is visible
    yield put(improvementsActions.setActiveTabId('actions'));

    // Re-fetch all suggestions so actionIds linkage is up to date
    yield call(initializeSuggestions);
  }

  yield call(sagaWrapper, { saga, type: action.type });
}
